import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import * as profile from './profile.actions';
import { Observable } from 'rxjs';
import { from } from 'rxjs/internal/observable/from';
// import { AddSuccessToastAction, AddErrorToastAction } from '../toaster/toaster.actions';
import { HttpService } from '../../global/http.service';
import { UpdateUserNotificationsSettingsAction, UpdateUserPreferencesAction, UpdateUserReportsAction } from '../auth/auth.actions';
import { CommonConstants, NotificationsSettings, Preferences } from '../../global/interfaces';
import { SetReportsCheckboxOptionsAction } from '../reports/reports.actions';
import { ReportsCheckboxes } from '../reports/reports.models';
// import { showToast } from '../../shared/utils';
import { ToastService } from '../../shared/toaster_/toaster_.service';
import { Actions as ActionsCDK } from 'atlas-cdk';

@Injectable()

export class ProfileEffects {
  public saveProfileConfig$ = createEffect(() => this.actions$.pipe(
    ofType<profile.SaveDataTablesConfigAction>(profile.ActionTypes.SAVE_DATA_TABLE_CONFIG),
    map(action => action.payload),
    switchMap(payload =>
      this.saveDataTablesConfig(payload).pipe(
        switchMap(() => [
          new UpdateUserPreferencesAction(payload),
          //new AddSuccessToastAction(CommonConstants.successToastMSG)

        ]),
        tap(() => {
          this._toasterService.launchAlertSuccess(CommonConstants.successToastMSG, ActionsCDK.success);
        }),
        catchError(error =>
        (from([
          new profile.SaveDataTablesConfigFailedAction(error)
        ])
        ))
      )
    )
  ));

  public saveNotificationsSettings$ = createEffect(() => this.actions$.pipe(
    ofType<profile.SaveNotificationsSettingsAction>(profile.ActionTypes.SAVE_NOTIFICATIONS_SETTINGS),
    map(action => action.payload),
    switchMap(payload =>
      this.saveNotificationsSettings(payload).pipe(
        switchMap(() => [
          new UpdateUserNotificationsSettingsAction(payload),
          // new AddSuccessToastAction(CommonConstants.successToastMSG),
        ]),
        tap(() => {
          this._toasterService.launchAlertSuccess(CommonConstants.successToastMSG, ActionsCDK.success);
        }),
        catchError(error =>
        (from([
          new profile.SaveNotificationsSettingsFailedAction(error)
        ])
        ))
      )
    )
  ));

  public saveProfileReportsConfig$ = createEffect(() => this.actions$.pipe(
    ofType<profile.SaveReportsConfigAction>(profile.ActionTypes.SAVE_REPORTS_CONFIG),
    map(action => action.payload),
    switchMap(payload =>
      this.saveReportsConfig(payload.checkboxes).pipe(
        switchMap(() => [
          new UpdateUserReportsAction(payload.checkboxes),
          new SetReportsCheckboxOptionsAction(payload),
          // new AddSuccessToastAction(CommonConstants.successToastMSG),
        ]),
        tap(() => {
          this._toasterService.launchAlertSuccess(CommonConstants.successToastMSG, ActionsCDK.success);
        }),
        catchError(error =>
        (from([
          new profile.SaveReportsConfigFailedAction(error)
        ])
        ))
      )
    )
  ));

  public constructor(
    private readonly actions$: Actions,
    private readonly http: HttpService,
    private readonly _toasterService: ToastService
  ) {
  }

  private saveDataTablesConfig(payload: Preferences): Observable<Preferences> {
    return this.http.put('/users/preferences', payload);
  }

  private saveNotificationsSettings(payload: NotificationsSettings): Observable<NotificationsSettings> {
    return this.http.put('/users/notifications-settings', payload);
  }

  private saveReportsConfig(payload: ReportsCheckboxes): Observable<ReportsCheckboxes> {
    return this.http.put('/users/monthly-report-settings', payload);
  }
}


